<template>
  <ValidationObserver
    ref="questionObserver" >
    <div
      v-for="(question, index) in questions"
      :key="question.id"
      class="question-fields" >
      <ValidationProvider
        :ref="`textareaProvider-${index}`"
        v-slot="{ errors, failedRules }"
        :name="`question-${index}`"
        :rules="schema.validators" >
        <!-- <div>{{  failedRules }}</div> -->
        <span
          class="question-header flex center-all gap-8"
          :class="{ 'mt-0': schema.noTopMargin && index === 0 }" >Question</span>
        <b-form-group >
          <div class="option flex gap-10">
            <div class="flex column gap-8 greedy">
              <SBTextInput
                :ref="`messageArea-${index}`"
                :focus-shadow="true"
                :placeholder="schema.placeholder"
                :show-tags-select="false"
                @input="textValueSync($event, index)"
                @raw-input="rawInputSync($event, index)" />
            </div>
            <SBIcon
              v-if="questions.length > schema.minQuestions"
              class="delete"
              :icon="SBIconList.CLOSE_THIN"
              :size="10"
              :color="SBColors.greyPrimary"
              :hover-icon-color="SBColors.blackPrimary"
              @click="removeOption(index)" />
          </div>
            
          <div
            v-if="initialized && errors[0]"
            class="error flex flex-align-center"
            :class="{ warning: warningValidators.includes(Object.keys(failedRules)[0])}">
            <SBIcon
              class="mr-1"
              :icon="warningValidators.includes(Object.keys(failedRules)[0]) ? SBIconList.INFO : SBIconList.ERROR"
              :color="warningValidators.includes(Object.keys(failedRules)[0]) ? '#DEBD30' : SBColors.redPrimary"
              :size="10" />
            <span>{{ schema.validatorMessages && schema.validatorMessages[Object.keys(failedRules)[0]] ? schema.validatorMessages[Object.keys(failedRules)[0]] : errors[0] }}</span>
          </div>
        </b-form-group>
      </ValidationProvider>
      <NMBRButtonsWrapper
        :ref="`buttons-${index}`"
        v-model="questions[index].buttons"
        class="d-block mt-2 sb2-bordered sb2-hoverable sb2-focusable"
        :class="{ 'button-indent': questions.length > 1 }"
        placeholder=""
        validators="required"
        :schema="btnSchema"
        @input="emitData" />
    </div>
    <!-- <pre class="debug">{{ questions.length }} {{ schema.options.length }}</pre> -->
    <div
      v-if="questions.length < schema.maxQuestions"
      class="add-more-question"
      :class="{ disabled: !valid }"
      @click="addNewquestion">
      <span class="flex flex-align-center">
        <img
          v-if="schema.addQuestionIcon && typeof schema.addQuestionIcon === 'string'"
          :src="schema.addQuestionIcon"
          style="width: 10px; height: 10px;"
          class="mr-1"
        >
        <SBIcon
          v-else-if="schema.addQuestionIcon"
          class="mr-2"
          :icon="schema.addQuestionIcon"
          :color="SBColors.bluePrimary"
          :size="8" />
        <span>{{ schema.addQuestionText }}</span>
      </span>
    </div>
  </ValidationObserver>
</template>

<script>
import randomString from '@/helpers/randomString';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBTextInput from '@/components/business/widgets/SBTextInput';
import { whatsappFormatMessage } from '@/helpers/stringHelpers';
import NMBRButtonsWrapper from './NMBRButtonsWrapper';

export default {
  name: 'QuestionsWrapper',
  components: {
    SBTextInput,
    SBIcon,
    NMBRButtonsWrapper,
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    schema: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      questions: [],
      returnData: [],
      valid: false,
      btnSchema: {
        noAddButton: false,
        minButtons: 0,
        maxButtons: 10,
        addButtonIcon: SBIconList.PLUS,
        addButtonText: 'Add Button',
        enter: 'add',
        returnKey: 'buttons',
        placeholder: 'Button text',
        blackButtons: true,
        value: [
          // { title: 'Button 1' },
          // { title: 'Button 2' },
          // { title: 'Button 3' },
        ],
      },
      initialized: false,
      setInitialValues: false,
      setDefaults: false,
      SBColors,
      SBIconList,
    };
  },
  computed: {
    warningValidators() {
      return this.schema.warningValidators ? this.schema.warningValidators.split(',') : [];
    },
  },
  watch: {
    questions: {
      handler() {
        this.$nextTick(() => {
          this.returnData = this.questions.map(question => ({
            text: whatsappFormatMessage(question.textValue).trim(),
            buttons: {
              value: question.buttons && question.buttons.data && question.buttons.data.value ? [...question.buttons.data.value] : [],
            },
          }));
          this.emitData();
        });
      },
      deep: true,
    },
    setInitialValues: {
      handler() {
        if (this.setInitialValues && this.setDefaults) {
          this.initialized = true;
          this.emitData();
        }
      },
      immediate: true,
    },
    setDefaults: {
      handler() {
        if (this.setInitialValues && this.setDefaults) {
          this.initialized = true;
          this.emitData();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.schema.value) {
      // this.questions = this.schema.value.map(question => ({ value: this. }));
      // const options = JSON.parse(JSON.stringify(this.schema.options));
      this.schema.value.forEach((question, index) => {
        this.questions.push({ textValue: question.text, rawInput: null, buttons: { data: question.buttons } });
      });
      this.btnSchema.minButtons = this.schema.minButtons || 0;
      this.btnSchema.maxButtons = this.schema.maxButtons || 10;

      setTimeout(() => {
        this.schema.value.forEach((question, index) => {
          this.$refs[`messageArea-${index}`][0].setHtml(question.text);
          // this.questions[index].buttons = question.buttons;
          // this.btnSchemaIndexed[index] = { ...this.btnSchema, value: question.buttons };
          this.$refs[`buttons-${index}`][0].setData(question.buttons.value);
        });
        this.$nextTick(() => {
          this.setInitialValues = true;
        });
      }, 0);
    } else {
      this.setInitialValues = true;
    }
    if (this.questions.length < this.schema.minQuestions) {
      for (let i = this.questions.length; i < this.schema.minQuestions; i += 1) {
        this.questions.push({ textValue: null, rawInput: null });
      }
      setTimeout(() => {
        this.setDefaults = true;
      }, 0);
    } else {
      this.setDefaults = true;
    }
    if (this.schema.stepID) {
      this.$eventBus.$on(`validate-${this.schema.stepID}`, () => {
        if (!this.$refs.questionObserver) return;
        this.$refs.questionObserver.validate();
      });
    }
  },
  methods: {
    textValueSync(textValue, index) {
      this.questions[index].textValue = textValue;
    },
    rawInputSync(rawInput, index) {
      const targetProviderRef = `textareaProvider-${index}`;
      this.questions[index].rawInput = rawInput;
      this.$refs[targetProviderRef][0].syncValue(rawInput);
      setTimeout(() => {
        this.$refs.questionObserver.validate();
      }, 0);
    },
    addNewquestion() {
      if (!this.valid) return;
      this.questions.push({ id: randomString(), textValue: '', rawInput: '' });
      // setTimeout(() => {
      this.emitData();
      // }, 0);
    },
    removeOption(index) {
      this.questions.splice(index, 1);
      setTimeout(() => {
        this.emitData();
      }, 0);
    },
    /** TODO this method(any some others) could be a part of a mixin for schema components. */
    onlyWarnings() {
      const fields = Object.values(this.$refs.questionObserver.fields).map(field => Object.keys(field.failedRules)).flat(Infinity);
      const someTest = fields.length ? !fields.some(failed => !this.warningValidators.includes(failed)) : false; // if there are no fields, return false because it means the field is validated silently and no failedRules are being recorded
      return someTest;
    },
    emitData(silent = true, reset = false) {
      if (!this.initialized) return;
      // console.log('this.$refs.buttonsObserver', this.$refs.buttonsObserver); return;
      if (!this.$refs.questionObserver) return;
      // console.log(2);
      this.$refs.questionObserver.validate({ silent })
        .then((valid) => {
          // console.log(3, valid);
          this.valid = valid || this.onlyWarnings();
          this.$emit('input', {
            valid: this.valid,
            name: this.schema.returnKey || '',
            data: {
              value: this.returnData,
            },
          });
        })
        .finally(() => {
          if (reset) this.$refs.questionObserver.reset();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.question-header {
  // text-transform: uppercase;
  margin: 8px 0;
  font-size: 11px;
  font-weight: 500;
  color: $blackUltralight;

  &:after {
    content: '';
    height: 1px;
    border-bottom: 1px dashed $greyBorder;
    flex-grow: 2;
  }
}

.question-fields {
  .form-group {
    &.has-subtitle {
      margin-bottom: 0 !important;
    }
  }
}

.button-indent {
  margin-right: 20px;
}

.add-more-question {
  // display: inline-block;
  color: $bluePrimary;
  padding: 0 0 0 0;
  margin-top: 8px;

  span {
    font-weight: 500;
    font-size: 14px;
  }

  &:hover {
    cursor: pointer;
    color: $blackPrimary;
    ::v-deep .sb-icon .mask {
      background-color: $blackPrimary !important;
    }
  }

  &.disabled {
    pointer-events: none;
    color: $greyLight;

    ::v-deep .icon.mask {
      background-color: $greyLight !important;
    }
  }
}

.option {
  .option-item {
    margin-bottom: 10px;
  }

  .delete {
    // margin-right: 0 !important;
    margin-top: 12px;
    cursor: pointer;
  }

  &:hover {
    .delete {
      display: flex;
    }
  }
}

.error * {
  font-size: 12px !important;
  line-height: 1 !important;
}

::v-deep .text-input-wrapper {
  border-radius: 10px !important;
  min-height: unset !important;
}

// ::v-deep {
//   .text-input-wrapper {
//     height: calc(var(--height) + 36px) !important;
//     max-height: calc(var(--height) + 36px) !important;

//     #vue-editor-wrapper {
//       height: var(--height) !important;
//       max-height: var(--height) !important;
//     }
//   }
// }
</style>
